<template>
  <div
    role="article"
    class="cardnews"
    :style="hasNewsUrl"
    @click="openNews(data.code, data.url)"
  >
    <div class="img-background" :style="computedBackground">
      <button
        data-testid="close-news"
        aria-label="Fechar"
        class="close-button expand-clickable-area"
        @click.stop="dismissNews(data.code)"
      >
        <RoundedIcon
          icon-name="ic_cancel"
          background-size="18"
          :main-color="NebraskaColors.neutralPrimary"
          :text-color="NebraskaColors.backgroundSecondary"
          :hover-color="NebraskaColors.backgroundHover"
          :hover-text-color="NebraskaColors.elementPrimary"
          has-hover
        />
      </button>
    </div>
    <div class="cardnews__content">
      <Heading :level="6" class="cardnews__title">
        {{ data.dashboardTitle }}
      </Heading>
      <BaseText size="xs">
        {{ data.dashboardSubtitle }}
      </BaseText>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

import { RoundedIcon, BaseText, Heading } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { NewsAPI } from '@/modules/home/services/news';
import { GtmTracker } from '@/modules/common/services/analytics';

const newsApi = new NewsAPI();

@Component({
  components: {
    RoundedIcon,
    BaseText,
    Heading
  }
})
export default class CardNewsContent extends Vue {
  private NebraskaColors = NebraskaColors;

  @Prop({ type: Object, required: true })
  private data!: any;

  public get computedBackground() {
    if (this.data.dashboardBackground) {
      return {
        backgroundImage: `url('${this.data.dashboardBackground}')`
      };
    } else {
      // Temporary default image
      return {
        backgroundImage: `url('https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MXwxMjA3fDB8MHxzZWFyY2h8Mnx8cmVhZGluZyUyMG5ld3N8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&w=1000&q=80')`
      };
    }
  }

  public get hasNewsUrl() {
    if (this.data.url)
      return {
        cursor: 'pointer'
      };

    return null;
  }

  @Emit('close')
  public dismissNews(code: string) {
    this.trackDismissNewsEvent(code);
    newsApi.trackNewsDiscard(code);
  }

  @Emit('open')
  public openNews(code: string, url: string) {
    if (!url) return;

    this.trackOpenNewsEvent(code);
    window.open(url);
    newsApi.trackNewsRead(code);
  }

  private get tracker() {
    return GtmTracker.trackerWithDefaultProps({
      category: 'Warren News'
    });
  }

  private trackOpenNewsEvent(code: string) {
    this.tracker({
      action: 'Open - News',
      label: code
    });
  }

  private trackDismissNewsEvent(code: string) {
    this.tracker({
      action: 'Dismiss - News',
      label: code
    });
  }

  @Emit()
  private close() {}
}
</script>

<style lang="less" scoped>
.cardnews {
  background-color: @background-tertiary;
  border-radius: 14px;
  width: 100%;
  height: 100%;
  position: relative;
}

.cardnews__content {
  padding: @size-spacing-x400;
  text-align: left;
}

.cardnews__title {
  margin-bottom: @size-spacing-x300;
}

.img-background {
  width: 100%;
  height: 158px;
  background-size: cover;
  background-position: center;
  border-radius: 8px 8px 0px 0px;
  z-index: 0;
}

.close-button {
  position: absolute;
  right: 19px;
  top: 19px;
  display: inline-flex;
}

.expand-clickable-area {
  padding: @size-spacing-x400;
  margin: calc(@size-spacing-x400 * -1);
}
</style>
